import { useQuery } from "@tanstack/react-query";

import { getDashboardStats } from "@/api";

export const dashboardQueryKeys = {
  useStats: () => ["dashboard", "stats"],
};

export const useDashboard = () => {
  const useStats = () =>
    useQuery({
      queryFn: () => getDashboardStats(),
      queryKey: dashboardQueryKeys.useStats(),
    });

  return { useStats };
};
